import { render, staticRenderFns } from "./prpDetails.vue?vue&type=template&id=2dbd462e"
import script from "./prpDetails.vue?vue&type=script&lang=js"
export * from "./prpDetails.vue?vue&type=script&lang=js"
import style0 from "./prpDetails.vue?vue&type=style&index=0&id=2dbd462e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports